import BaseModelAPI from '../BaseModelAPI';

export default class StockAdjustment extends BaseModelAPI {
	static entity = 'stockadjustment';
	static entityName = 'stockadjustment';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockAdjustmentNumber = '';
			this.stockAdjustmentDate = '';
			this.stockAdjustmentTypeId = '';
			this.stockAdjustmentType = {};
			this.stockAdjustmentDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}